import {v4 as guid} from 'uuid';
import * as requestFromServer from './invitedUsersCrud';
import {
  invitedUsersSlice,
  callTypes
} from './invitedUsersSlice';
import {RequestCancellationManager} from '../../_common/utils/RequestCancellationManager';

export const getInvitedUsersListIDPrefix = 'getInvitedUsersList';
const {actions} = invitedUsersSlice;

const getInvitedUsersList = storeMethod => queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.list}));

  const requestID = `${getInvitedUsersListIDPrefix}-${guid()}`;
  const cancellationHandlers = RequestCancellationManager.createCancellationHandlers(requestID);

  return requestFromServer
    .findInvitedUsers(queryParams, cancellationHandlers)
    .then(response => {
      const {errorCode, data: {totalInvitedUsersCount: totalCount, pageCount, list}} = response.data;
      if (errorCode !== 0) throw new Error();

      dispatch(storeMethod({
        totalCount,
        pageCount,
        entities: list
      }));
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t find data';
      dispatch(actions.catchError({error, callType: callTypes.list}));
    })
    .finally(() => {
      RequestCancellationManager.forgetRequest(requestID);
    });
};

export const getInvitedUsers = getInvitedUsersList(actions.invitedUsersFetched);
export const getNextInvitedUsers = getInvitedUsersList(actions.invitedUsersAppended);

export const exportInvitedUsersFileAction = queryParams => () => {
  return requestFromServer
    .findInvitedUsersForExcel(queryParams)
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      return data.list;
    });
};
